import React, { useState } from 'react'
import VisibilitySensor from 'react-visibility-sensor'

const VisibilitySensorOnce = props => {
    
    const [visibleActive ,setVisibleActive] = useState(false)

    const onChangeVisibility = isActive => {
        setVisibleActive(isActive);
    }
    
    return (
        <VisibilitySensor { ...props } onChange={e => onChangeVisibility(e)} active={!visibleActive}>
            { props.children }
        </VisibilitySensor>
    )
}

export default VisibilitySensorOnce
